import React, { useState } from "react";
import {
  Table,
  Button,
  Checkbox,
  Select,
  Spin,
  Popconfirm,
  message,
  Form,
  Input,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SaveOutlined,
  RollbackOutlined,
  PercentageOutlined,
} from "@ant-design/icons";

const { Option } = Select;

const NewMappingTable = (props) => {
  const [tableData, setTableData] = useState(props.initialData);
  const [editingKey, setEditingKey] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  React.useEffect(() => {
    setTableData(props.initialData);
  }, [props.initialData]);

  const toggleEditMode = () => {
    setIsEditing(!isEditing);
    setEditingKey("");
  };

  const handleSave = () => {
    let selectedColumns = tableData.map(
      (item) => item["source1"] + "-" + item["rowKey"]
    );

    props.assignDataSource(tableData, selectedColumns, true);
    props.editMappingName(true);
    setIsEditing(false);
  };

  const handleAddRow = () => {
    const newRow = {
      key: Date.now().toString(),
      rowKey: false,
      mappingName: props.mappingName,
      source1: "",
      source2: "",
      fieldType: "TEXT",
    };
    setTableData((prevData) => [...prevData, newRow]);
    let selectedColumns = tableData.map(
      (item) => item["source1"] + "-" + item["rowKey"]
    );

    props.assignDataSource(tableData, selectedColumns, false);
  };
  const handleDelete = (record) => {
    const newDataSource = tableData.filter((item) => item.key !== record.key);
    setTableData(newDataSource);
    let selectedColumns = tableData.map(
      (item) => item["source1"] + "-" + item["rowKey"]
    );
    props.assignDataSource(tableData, selectedColumns, false);
  };
  const handleChange = (key, field, value) => {
    const newData = [...tableData];
    const index = newData.findIndex((item) => item.key === key);
    if (index > -1) {
      newData[index][field] = value;
      setTableData(newData);
    }
  };

  const columns = [
    {
      title: "Unique Identifier",
      dataIndex: "rowKey",
      key: "rowKey",
      render: (text, record) => {
        return isEditing ? (
          <Checkbox
            checked={record.rowKey}
            onChange={(e) =>
              handleChange(record.key, "rowKey", e.target.checked)
            }
          />
        ) : (
          <Checkbox checked={record.rowKey} disabled />
        );
      },
    },
    {
      title: props.dataSourceOne,
      dataIndex: "source1",
      key: "source1",
      render: (text, record) => {
        return isEditing ? (
          <Select
            value={record.source1}
            onChange={(value) => handleChange(record.key, "source1", value)}
            style={{ width: "100%" }}
            showSearch
          >
            {props.fileHeader.map((d, index) => (
              <Option value={d.replace(/(^"|"$)/g, "")}>
                {d.replace(/(^"|"$)/g, "")}
              </Option>
            ))}
          </Select>
        ) : (
          text
        );
      },
    },
    {
      title: props.dataSourceTwo,
      dataIndex: "source2",
      key: "source2",
      render: (text, record) => {
        return isEditing ? (
          <Select
            value={record.source2}
            onChange={(value) => handleChange(record.key, "source2", value)}
            style={{ width: "100%" }}
            showSearch
          >
            {props.sqlHeader.map((d, index) => (
              <Option value={d}>{d}</Option>
            ))}
          </Select>
        ) : (
          text
        );
      },
    },
    {
      title: "Field Type",
      dataIndex: "fieldType",
      key: "fieldType",
      render: (text, record) =>
        isEditing ? (
          <Select
            value={record.fieldType || "TEXT"}
            onChange={(value) => handleChange(record.key, "fieldType", value)}
            style={{ width: "100%" }}
          >
            <Option value="TEXT">Text</Option>
            <Option value="DATE">Date</Option>
            <Option value="DATETIME">Date &amp; Time</Option>
            <Option value="NUMERIC">Number</Option>
          </Select>
        ) : (
          <span style={{ fontSize: 12, color: "var(--color-text-secondary)" }}>
            {text || "Text"}
          </span>
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      width: "15%",
      render: (_, record) =>
        isEditing ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button
              type="primary"
              danger
              style={{ marginLeft: 8 }}
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <div>
      <Table
        loading={{
          spinning: props.tableLoading,
          tip: "Loading mapping",
          indicator: <Spin size="large" />,
        }}
        columns={columns}
        dataSource={tableData}
        rowClassName={(record) =>
          isEditing && editingKey === record.key ? "editable-row" : ""
        }
        pagination={false}
      />
      <Button
        onClick={isEditing ? handleSave : toggleEditMode}
        type="primary"
        style={{ marginBottom: 16, marginTop: 16 }}
      >
        {isEditing ? "Save Changes" : "Edit Table"}
      </Button>
      {isEditing && (
        <Button
          onClick={handleAddRow}
          type="primary"
          style={{ marginTop: 16, marginBottom: 16, marginLeft: 8 }}
        >
          Add Row
        </Button>
      )}
    </div>
  );
};

export default NewMappingTable;
